import { ConfigOption } from '@ngx-formly/core';
import { CustomEntityDropDownComponent } from "./components/custom-entity-drop-down/custom-entity-drop-down.component";

export const CUSTOM_ENTITY_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-custom-entity-drop-down', component: CustomEntityDropDownComponent, wrappers: ['simple-title'], },
]
